<template>
  <div class="wafe" style="min-width:280px;max-width:420px;">
    <inside-header title="提现记录" />
    <div v-if="promoter_withdrawal.length === 0 && !loading">
      <a-empty />
    </div>
    <div v-else>
      <div v-for="(item, index) in promoter_withdrawal" :key="index" class="info"
        style="height:80px;padding:20px 20px 20px 15px;">
        <div class="cake">
          <span>提现-支付宝</span>
        </div>
        <div class="node">
          <span class="mode" style="">{{ item.create_time | dayFormat }}</span>
          <span class="lode" style="">{{ item.create_time | minFormat }}</span>
          <span class="make" style="">{{ item.amount }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { InsideHeader } from '@/components'
export default {
  name: 'UserWithdrawalRecord',
  components: {
    InsideHeader
  },
  filters: {
    dayFormat(val) {
      var stime = val * 1000
      var date = new Date(stime)
      //   var y = date.getFullYear()
      var m = date.getMonth() + 1
      var d = date.getDate()
      return m + '月' + d + '日'
    },
    minFormat(val) {
      var stime = val * 1000
      var date = new Date(stime)
      var h = date.getHours()
      var m = date.getMinutes()
      return h + ':' + m
    }
  },
  data() {
    return {
      loading: true,
      promoter_withdrawal: []
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      this.$http({
        url: 'index/promote/relevant',
        method: 'get'
      }).then(res => {
        this.loading = false
        console.log(res)
        if (res.status === 'success') {
          var data = res.data
          this.promoter_withdrawal = data.promoter_withdrawal
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
    .wafe {
        min-width: 280px;
        max-width:420px;
        .info {
            height:80px;
            padding:20px 20px 20px 15px;
            .cake {
                font-size:16px;
                line-height:25px;
                color:#333333;
            }
            .node {
                .mode{
                    font-size:14px;line-height:28px;color:#999999;
                }
                .lode {
                font-size:14px;line-height:28px;color:#999999;margin-left:5px;
            }
            .make {
                font-size:16px;float:right;line-height:28px;color:#333333;position:relative;top:-13px;
            }
          }
        }
    }
</style>
